export const QuarantineContactIcon = () => {
  return (
    <svg
      data-name="Grupo 7102"
      height="30.769"
      id="Grupo_7102"
      viewBox="0 0 38.036 35.769"
      width="32.036"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse
        cx="9.648"
        cy="9.648"
        data-name="Elipse 1841"
        fill="#ff715b"
        id="Elipse_1841"
        rx="9.648"
        ry="9.648"
        transform="translate(5.675 0)"
      />
      <path
        d="M1193.516,730.868a3.081,3.081,0,0,1-.54.032,4.857,4.857,0,0,1-1.9-.381,5.057,5.057,0,0,1-3.142-5.967v-.063a5.3,5.3,0,0,1,.794-1.714,5.858,5.858,0,0,1-.667-1.428l-.032-.064-.032-.063a5.072,5.072,0,0,1,3.714-6.157h.063a4.843,4.843,0,0,0-.508-.349,1.3,1.3,0,0,0-1.428,0,11.833,11.833,0,0,1-13.616,0,1.24,1.24,0,0,0-1.428,0c-5.4,3.586-6.919,10.537-6.919,10.537s-1.4,5.713,4.253,5.713h21.392C1193.548,730.932,1193.516,730.9,1193.516,730.868Z"
        data-name="Trazado 4391"
        fill="#ff715b"
        id="Trazado_4391"
        transform="translate(-1167.719 -695.194)"
      />
      <path
        d="M1253.434,725.308a1.679,1.679,0,0,1,2.031,1.27v.063a1.824,1.824,0,0,1-1.238,2.158,1.946,1.946,0,0,1-2.349-1.016c-.413-.825-1.016-1.016-1.745-.508-.825.508-.921.92-.413,1.841a1.871,1.871,0,1,1-3.079,0c.1-.19.317-.413.317-.6.1-.73-.317-1.238-1.142-1.555-.317-.1-1.016.413-1.238.825a1.775,1.775,0,0,1-2.317.952.031.031,0,0,1-.032-.032,1.9,1.9,0,0,1,.825-3.682,2.072,2.072,0,0,0,1.143-.317c.317-.19.317-1.333,0-1.428a5.707,5.707,0,0,0-1.016-.19,2.048,2.048,0,0,1-2.063-1.428,1.925,1.925,0,0,1,1.4-2.317,1.89,1.89,0,0,1,2.19,1.079,1.041,1.041,0,0,0,1.238.73.757.757,0,0,0,.412-.222c.921-.508.921-.92.413-1.841a1.911,1.911,0,0,1,.413-2.476,1.89,1.89,0,0,1,2.634.159,1.818,1.818,0,0,1,.127,2.285,2.13,2.13,0,0,0-.317.73,1.282,1.282,0,0,0,1.111,1.428,1.307,1.307,0,0,0,1.365-.825,1.786,1.786,0,0,1,2.317-.952c.032,0,.032,0,.064.032a1.909,1.909,0,0,1,1.238,2.063,2.005,2.005,0,0,1-1.968,1.555,4.447,4.447,0,0,0-1.238.317c-.317.1-.317,1.143,0,1.333C1252.609,724.991,1253.117,725.086,1253.434,725.308Zm-3.9-1.238a1.238,1.238,0,0,0-2.476,0,1.22,1.22,0,0,0,1.238,1.238,1.26,1.26,0,0,0,1.238-1.238Z"
        fill="#ff715b"
        id="Trazado_3299_00000089568597554137281250000005541755657074025345_"
        transform="translate(-1217.703 -696.331)"
      />
    </svg>
  );
};
